// ************** fronto.emphasis.js **************
// concerns "generating" emphasis
// should be stand-alone (no dependency on the other JS files, but on vegaEmbed)

import * as d3 from 'd3';
import * as Fronto from "./utility.js";

export function frontoEmphasisGenerator(placeSelector, emphSpec, viewname, dblClick) {
  // get boostrap icon
  function biFormat(icon) {
    return "<i class=\"bi bi-" + icon + "\"></i>";
  }
  function imageFormat(path, width, height) {
    if (width !== undefined && height !== undefined) {
      return "<img src=\"" + path + "\" style=\"width: " + Fronto.unitString(width, "px") + "; height: " + Fronto.unitString(height, "px") + ";\" />";
    } else if (width !== undefined) {
      return "<img src=\"" + path + "\" style=\"width: " + Fronto.unitString(width, "px") + ";\" />";
    } else if (height !== undefined) {
      return "<img src=\"" + path + "\" style=\"height: " + Fronto.unitString(height, "px") + ";\" />";
    } else {
      return "<img src=\"" + path + "\" />";
    }

  }
  // color Control
  function getRGBA(colorExpr, opacity) {
    let cObj;
    if (colorExpr) cObj = d3.color(colorExpr);
    else cObj = d3.color("#222222");
    if (opacity) cObj.opacity = opacity;
    return "rgba(" + cObj.r + "," + cObj.g + "," + cObj.b + "," + cObj.opacity + ")";
  }

  if (emphSpec.length > 0) {
    d3.select(placeSelector + " .chart-wrapper").style("position", "relative");
    let annoLayer = d3.select(placeSelector + " .chart-wrapper"); // directly include to the chart-wrapper to allow for tooltip interaction
    // pre-processing
    emphSpec.forEach((d) => {
      // setting the CSS transform (relative position)
      let transformStates = [];
      if (d.dx !== undefined) {
        transformStates.push("translateX(" + Fronto.unitString(d.dx, "px") + ")");
      }
      if (d.dy !== undefined) {
        transformStates.push("translateY(" + Fronto.unitString(d.dy, "px") + ")");
      } else {
        transformStates.push("translateY(-50%)");
      }
      if (d.rotate) {
        transformStates.push("rotate(" + Fronto.unitString(d.rotate, "deg") + ")");
      }
      if (d.mark?.shape === "rule") {
        if (d.width && d.height) {
          let ang = Fronto.unitString(Fronto.round(Math.atan2(d.height, d.width) * 180 / Math.PI, 2), "deg");
          transformStates.push("rotate(" + ang + ")");
        }
      }
      d.cssTransform = transformStates.join(" ");
    });

    // d3 handling
    let emphasisElements = annoLayer.selectAll("emphasis").data(emphSpec).join("emphasis").style("display", "block");
    // make anno/numbering
    emphasisElements.attr("data-role", "informaltionalMarks");
    emphasisElements.attr("data-name", (d) => d.name);
    emphasisElements.html((d) => {
      if (d.mark?.icon) {
        if (d.mark.icon.constructor.name === "String") return biFormat(d.mark.icon);
        else if (d.mark.icon.constructor.name === "Array") return d.mark.icon.map(icon => biFormat(icon)).join(" ");
      }
      else if (d.mark?.image) return imageFormat(d.mark.image, d.width, d.height);
      else return '';
    });
    emphasisElements.style("box-sizing", "border-box");
    emphasisElements.style("width", (d) => {
      return (d.width !== undefined ? Fronto.unitString(d.width, "px") : 0)
    });
    emphasisElements.style("height", (d) => {
      if (d.mark?.shape === "rule") return Fronto.unitString(d.mark.strokeWidth || 1, + "px");
      else return (d.height !== undefined ? Fronto.unitString(d.height, "px") : 0)
    });
    emphasisElements.style("position", "absolute");
    emphasisElements.style("left", (d, i, nodes) => {
      let x = +d.x ? +d.x : 0;
      let w = parseFloat(d3.select(nodes[i]).style("width"));
      w = +w ? +w : 0;
      return x + "px";
    });
    emphasisElements.style("top", (d) => Fronto.unitString(+d.y ? +d.y : 0, "px"));
    emphasisElements.style("transform", (d) => (d.cssTransform !== undefined ? d.cssTransform : null));
    emphasisElements.style("opacity", (d) => (d.opacity !== undefined ? d.opacity : 1));
    emphasisElements.style("font-size", (d) => Fronto.unitString(d.height || 14, "px"));
    emphasisElements.style("font-stretch", (d) => {
      if (d.mark?.icon !== undefined) {
        let h = d.height || 14;
        let w = d.width || 14;
        return Fronto.unitString(Math.round(w / h * 100), '%');
      }
    });
    emphasisElements.style("background-color", (d) => {
      if (d.mark?.shape !== undefined && d.mark?.shape !== "rule") return getRGBA(d.mark?.fill, d.mark?.opacity);
      else if (d.mark?.shape === "rule") return getRGBA(d.mark?.stroke, d.mark?.opacity);
    });
    emphasisElements.style("color", (d) => {
      if (d.mark?.icon !== undefined) return getRGBA(d.mark?.fill, d.mark?.opacity);
    });
    emphasisElements.style("border-radius", (d) => {
      if (d.mark?.shape === "circle") return Fronto.unitString(d.width / 2, "px") + " / " + Fronto.unitString(d.height / 2, "px");
      else if (d.mark?.radius) return Fronto.unitString(radius, "px");
      else return 0;
    });
    emphasisElements.style("border-color", (d) => {
      if (d.mark?.shape !== undefined) return getRGBA(d.mark?.stroke, d.mark?.strokeOpacity);
    });
    emphasisElements.style("border-style", (d) => {
      if (d.mark?.shape !== undefined) return (d.mark.strokeStyle || "solid");
      else return "solid";
    });
    emphasisElements.style("border-width", (d) => {
      if (d.mark?.shape !== undefined && d.mark?.shape !== "rule") return Fronto.unitString(d.mark.strokeWidth || 0, "px");
      else return 0;
    });
    emphasisElements.on("dblclick", dblClick);
  }
}
